import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { EDIShippingNotesByPartReportDto } from "@interfaces/dto/reports/ediShippingNotesByPartReportDto.interface";
import { OutsideProcessContractsSentButNotReceivedReportDto } from "@interfaces/dto/reports/OutsideProcessContractsSentButNotReceivedReportDto.interface";

@Injectable()
export class ReportService {
	endpoint = "Report";

	constructor(private http: HttpClient) {}

	ediShippingNotesByPart(parameters: EDIShippingNotesByPartReportDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/EDIShippingNotesByPart`, parameters);
	}

	outsideProcessContractsSentButNotReceived(parameters: OutsideProcessContractsSentButNotReceivedReportDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/OutsideProcessContractsSentButNotReceived`, parameters);
	}
}